import { Controller } from "../vendor/stimulus.js";

export default class extends Controller {
  static targets = [];

  connect() {
    // Runs whenever data-controller="wpki" elements appear
    this.element.dataset.wpkiController = "connected";
  }
}
